import { Button, Modal } from 'app/components';
import React, {useState} from 'react';
import { UserFocus } from '@phosphor-icons/react'

const QRScanCard = ({ className }) => {
  const [modal, openModal] = useState(false);
  return(
  <div className={`flex justify-center w-full ${className || ''}`}>
      <div className="info-card-wrapper rounded-xl px-6 py-5 flex items-center justify-between gap-5 bg-red-50 w-full max-w-[660px] h-[100px]">
              <div className="icon p-2 bg-white rounded-full">
                <UserFocus size={32} className="text-rose-500" />
              </div>
    
              <div className="info text-[16px] flex-1">
                <p className="font-bold text-rose-500">Instant Ticket Check-In.</p>
                <p className="text-black">
                  Easily scan and verify tickets using your smartphone with our mobile-friendly{' '}
                  <span className="font-bold text-rose-500">Check-In App.</span>
                </p>
              </div>
    
              <Button type="primary-black" size="small" className="text-[16px]" onClick={() => { openModal(true) }}>
                Scan QR
              </Button>
              {
                modal && (
                    <Modal
                    isOpen={modal}
                    onClose={() => openModal(false)}
                    hasClose={true}
                    title={<div className="w-full text-center relative left-[15px]">Scan QR Code</div>}
                    className="bg-gray-900 bg-opacity-80 flex items-center justify-center"
                    size="qrcode"
                >
                    <div className="absolute left-0 right-0 bg-neutral-700 p-10 flex flex-col items-center justify-center">
                        <div className="bg-white p-4">
                            <img src = "assets/images/QRCode.png"
                                className="w-full max-w-xs"
                            />
                        </div>
                    </div>
                </Modal>
                )
              }
            </div>
          </div>)
}

export default QRScanCard;
